import { EditorType } from '../enums/marketplace-enums';
var clientConfig = {};
export var setConfig = function (conf) {
    //PLEASE do not add anything to this deprecated file!!!
    clientConfig.goto = conf.goto;
    clientConfig.baseApiUrl = conf.baseApiUrl;
    clientConfig.origin = conf.origin;
    clientConfig.sentryClient = conf.sentryClient;
    clientConfig.marketplaceStaticsUrl = conf.marketplaceStaticsUrl;
    clientConfig.goToHomePage = conf.goToHomePage;
    clientConfig.goToManageApps = conf.goToManageApps;
    clientConfig.goBackToReferrer = conf.goBackToReferrer;
    clientConfig.installApp = conf.installApp;
    clientConfig.editorUrl = conf.editorUrl;
    clientConfig.editorType = conf.editorType;
    clientConfig.manageAppsMainButtonAction = conf.manageAppsMainButtonAction;
    clientConfig.originForBI =
        conf.origin === 'bizmgr'
            ? (conf.editorType === EditorType.ADI ? 'adi_' : '') + "dashboard"
            : conf.origin;
    clientConfig.manageAppsStaticsUrl = conf.manageAppsStaticsUrl;
    //PLEASE do not add anything to this deprecated file!!!
};
export var config = {
    get goto() {
        return clientConfig.goto;
    },
    get baseApiUrl() {
        return clientConfig.baseApiUrl;
    },
    get origin() {
        return clientConfig.origin;
    },
    get marketplaceStaticsUrl() {
        return clientConfig.marketplaceStaticsUrl;
    },
    get goToHomePage() {
        return clientConfig.goToHomePage;
    },
    get goToManageApps() {
        return clientConfig.goToManageApps;
    },
    get goBackToReferrer() {
        return clientConfig.goBackToReferrer;
    },
    get sentryClient() {
        return clientConfig.sentryClient;
    },
    get esi() {
        return clientConfig.esi;
    },
    get installApp() {
        return clientConfig.installApp;
    },
    get originForBI() {
        return clientConfig.originForBI;
    },
    get editorUrl() {
        return clientConfig.editorUrl;
    },
    get editorType() {
        return clientConfig.editorType;
    },
    get manageAppsMainButtonAction() {
        return clientConfig.manageAppsMainButtonAction;
    },
    get manageAppsStaticsUrl() {
        return clientConfig.manageAppsStaticsUrl;
    },
};
//# sourceMappingURL=config.js.map